import { useAddOrUpdateUserTeamMemberRoleMutation } from '../__generated__/mutations.generated';

function useAddOrUpdateUserTeamMemberRole(refetchQueries = ['TeamForMembersPage']) {
  const [addOrUpdateUserTeamMemberRole, { loading }] = useAddOrUpdateUserTeamMemberRoleMutation({
    refetchQueries,
    awaitRefetchQueries: true,
  });

  return { addOrUpdateUserTeamMemberRole, loading };
}

export { useAddOrUpdateUserTeamMemberRole };
